/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBan: {
  name: 'ban';
  data: string;
} = {
  name: 'ban',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.76 3.073a6.5 6.5 0 0 1 9.167 9.167.503.503 0 0 0-.073-.094l-9-9a.501.501 0 0 0-.094-.073Zm-.687.687a6.5 6.5 0 0 0 9.167 9.167.503.503 0 0 1-.094-.073l-9-9a.501.501 0 0 1-.073-.094ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
